import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import UnidadeExecutoraForm from "../../../components/forms/UnidadeExecutoraForm.vue";
import { UnidadeExecutoraService } from "../../../services/UnidadeExecutoraService";

export default {
  name: "EditarUnidadeExecutora",
  components: {
    Breadcrumb,
    UnidadeExecutoraForm
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Unidades Executoras",
          disabled: false,
          href: "/gerenciar-unidades-executoras"
        },
        {
          text: "Editar Unidade Executora",
          disabled: true,
          href: "/unidades-executoras/editar"
        }
      ],
      unidadeExecutoraData: null,
      loading: false
    };
  },
  async created() {
    await this.carregarUnidadeExecutora();
  },
  methods: {
    async carregarUnidadeExecutora() {
      try {
        this.loading = true;
        const id = this.$route.params.id;
        const response = await UnidadeExecutoraService.show(id);
        
        if (response && response.data) {
          this.unidadeExecutoraData = response.data;
        } else {
          throw new Error('Unidade Executora não encontrada');
        }
      } catch (error) {
        console.error('Erro ao carregar Unidade Executora:', error);
        this.$globalAlert('Erro ao carregar dados da Unidade Executora', 'error');
        this.$router.push('/gerenciar-unidades-executoras');
      } finally {
        this.loading = false;
      }
    },
    
    async handleSave(formData) {
      try {
        this.loading = true;
        
        // Criar FormData para atualização
        const postData = new FormData();
        postData.append("_method", "PUT"); // Para método PUT
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_unidade", formData.codigo_unidade);
        postData.append("nome", formData.nome);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const id = this.$route.params.id;
        const response = await UnidadeExecutoraService.update(id, postData);
        
        if (response) {
          this.$router.push('/gerenciar-unidades-executoras');
        } else {
          throw new Error('Erro ao atualizar Unidade Executora');
        }
      } catch (error) {
        console.error('Erro ao atualizar Unidade Executora:', error);
        this.$globalAlert('Erro ao atualizar Unidade Executora', 'error');
      } finally {
        this.loading = false;
      }
    },
    
    handleCancel() {
      // Retornar para a tela de listagem das Unidades Executoras
      this.$router.push('/gerenciar-unidades-executoras');
    }
  }
};
